import { ImageLink, Link, LinkButton, NavigationLink, SvgLink } from '../../navigation.utils';
import { INJECT_BUTTON_TO_FOOTER_LINKS_SECTION, InjectButtonToFooterLinksSectionAction } from '../../navigation.actions';

export interface FooterState {
  linksSection: {
    links: Array<NavigationLink>;
    buttons?: Array<LinkButton>;
  };
  socialSection: {
    title: string;
    imageLinks: Array<SvgLink>;
  } | null;
  appsSection: {
    title: string;
    imageLinks: Array<ImageLink>;
  } | null;
  bottomFooterBar: {
    year: number;
    rightsReservedText: string;
    poweredByLink: Link;
  };
  logo: SvgLink;
}

export type FooterAction = InjectButtonToFooterLinksSectionAction;
export const footerReducer = (state: FooterState = {} as FooterState, action: FooterAction) => {
  switch (action.type) {
    case INJECT_BUTTON_TO_FOOTER_LINKS_SECTION: {
      const { text, onClick } = action;
      const { buttons } = state.linksSection;
      return {
        ...state,
        linksSection: {
          ...state.linksSection,
          buttons: [
            ...(buttons || []),
            {
              text,
              onClick,
            },
          ],
        },
      };
    }
    default:
      return state;
  }
};
